import React from 'react';
import { Box, Container, Typography, Link, Divider, GridLegacy as Grid, Paper } from '@mui/material';
import { Email, Feedback, LinkedIn, YouTube } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ContactFooter = () => {
  const { t } = useTranslation();

  return (
    <Paper elevation={1} sx={{ mt: 6, py: 4, bgcolor: 'grey.50' }}>
      <Container maxWidth="xl">
        <Divider sx={{ mb: 3 }} />
        
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
              <Email sx={{ mr: 1 }} />
              {t('contact')}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              Bachar Rifai
            </Typography>
            <Link 
              href="mailto:bacrifai@amazon.com" 
              sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
            >
              <Email sx={{ mr: 1, fontSize: 18 }} />
              bacrifai@amazon.com
            </Link>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
              <Feedback sx={{ mr: 1 }} />
              {t('feedback')}
            </Typography>
            <Link 
              href="https://app.smartsheet.com/b/form/8d23ba71313048b884876896b30a68d9"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Feedback sx={{ mr: 1, fontSize: 18 }} />
              {t('feedbackForm')}
            </Link>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
              <LinkedIn sx={{ mr: 1 }} />
              LinkedIn
            </Typography>
            <Link 
              href="https://www.linkedin.com/in/bachar-rifai-0890549/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <LinkedIn sx={{ mr: 1, fontSize: 18 }} />
              {t('linkedinProfile')}
            </Link>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
              <YouTube sx={{ mr: 1 }} />
              YouTube
            </Typography>
            <Link 
              href="https://www.youtube.com/@RdsTools"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <YouTube sx={{ mr: 1, fontSize: 18 }} />
              RdsTools
            </Link>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3 }} />
        
        <Box textAlign="center">
          <Typography variant="body2" color="text.secondary">
            {t('footerNote')}
          </Typography>
        </Box>
      </Container>
    </Paper>
  );
};

export default ContactFooter;
